import { createReducer, PayloadAction } from '@reduxjs/toolkit';
import { initialState } from '@modules/orders-and-trips/store';
import { showFormRoutine } from '@modules/orders-and-trips/actions';
import { FormType } from '@modules/orders-and-trips/types/general';

export const showFormReducer = createReducer(initialState, {
  [showFormRoutine.REQUEST]: (state) => {
    return state;
  },
  [showFormRoutine.SUCCESS]: (
    state,
    action: PayloadAction<{
      formType: FormType | null;
    }>
  ) => {
    const { formType } = action.payload;
    state.showForm = formType;
    return state;
  },
  [showFormRoutine.FAILURE]: (state) => {
    return state;
  },
  [showFormRoutine.FULFILL]: (state) => {
    return state;
  }
});

